import React, {useEffect, useState} from "react";
import * as instituteService from "../../../services/institute";
import {Col, Container, Row} from "reactstrap";
import ViberHeader from "../../../components/header-new/ViberHeader";
import CourseSlidesV2 from "../../../components/CourseSlides/CourseSlidesV2";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {useDispatch, useSelector} from "react-redux";

export default function TeacherCoursesV1() {

    const dispatch = useDispatch();

    const [teachers, setTeachers] = useState([])
    const [teacher, setTeacher] = useState({
        classes: [],
        teacherId: -1,
        courses: [],
        teacherName: "",
    })

    const spinnerHandler = (data) => dispatch(actionSpinnerCreator.spinnerHandler(data));
    const userType = useSelector(state => state.auth.userType);

    useEffect(() => {
        (async function () {

            try {

                spinnerHandler({isSpin: true, type: 15});

                const response = await instituteService.getInstituteTeachers();

                if (response && response.success && response.body.teachers) {
                    const allTeachers = response.body.teachers;
                    setTeachers(allTeachers)

                    const teacherDetails = await instituteService.getTeacherDetails(allTeachers.length > 0 ? allTeachers[0].id : -1)

                    if (teacherDetails && teacherDetails.success && teacherDetails.body) {
                        const body = teacherDetails.body

                        let data = {
                            classes: body.classes,
                            teacherId: body.id,
                            courses: body.courses,
                            teacherName: body.name
                        };
                        setTeacher(data);
                    }
                }

                spinnerHandler(false);

            } catch (e) {
                console.log(e)
            }

        })()
    }, []);

    return (
        <Container fluid className={"p-0 viber-layout"}>

            <Row className={"no-gutters"}>
                <ViberHeader/>
            </Row>

            {
                teacher && teacher.courses.length !== 0 ? <Row className={"no-gutters"} style={{paddingTop: 60}}>
                    <Col>
                        {
                            teacher && teacher.courses.length !== 0 &&
                            <section className="container class-section">
                                <div style={{
                                    textAlign: "center",
                                    color: "#090914",
                                    fontWeight: "bold",
                                    fontSize: 46,
                                    fontFamily: '"Gilroy Medium"'
                                }}>
                                    Our Courses
                                </div>
                                {/* <h3 className={"class-ctrl"}>Classes</h3> */}
                                <CourseSlidesV2 courses={teacher.courses} classesByLecture={[]}
                                                privileges={""}/>
                            </section>
                        }
                    </Col>
                </Row> : <></>
            }

            <Row style={{marginTop: 80}} className={"no-gutters border"}>
                <Col xl={12}>
                    <CardsFooter/>
                </Col>
            </Row>

        </Container>
    );
}